<template>
    <div class="text-purple-600">
    <p class="text-3xl font-bold text-center">Trusted by thousands of schools and loved by pupils</p>
        <!-- <p class="text-secondary text-xl md:text-3xl text-center font-thin">Trusted by <span
                  class="font-bold">thousands</span> of <span class="font-bold">schools</span> and <span
                  class="font-bold">loved</span> by <span class="font-bold">pupils</span></p> -->

        <div class="flex justify-center items-center py-10 space-x-5">
            <img class="w-20 md:w-28"
                 src="https://cdn.satscompanion.com/images/meeting-quotes/1.png"
                 alt="">
            <img class="w-20 md:w-28"
                 src="https://cdn.satscompanion.com/images/meeting-quotes/2.png"
                 alt="">
            <img class="w-20 md:w-28"
                 src="https://cdn.satscompanion.com/images/meeting-quotes/3.png"
                 alt="">
            <img class="w-20 md:w-28"
                 src="https://cdn.satscompanion.com/images/meeting-quotes/4.png"
                 alt="">
            <img class="w-20 md:w-28"
                 src="https://cdn.satscompanion.com/images/meeting-quotes/5.png"
                 alt="">
            <img class="w-20 md:w-28"
                 src="https://cdn.satscompanion.com/images/meeting-quotes/6.png"
                 alt="">
            <img class="w-20 md:w-28"
                 src="https://cdn.satscompanion.com/images/meeting-quotes/7.png"
                 alt="">
            <img class="w-20 md:w-28"
                 src="https://cdn.satscompanion.com/images/meeting-quotes/8.png"
                 alt="">
        </div>
    </div>
</template>

<script>
export default {
    props: {},

    data() {
        return {}
    },

    computed: {},

    methods: {},

    watch: {},

    mounted() { }
};
</script>